<template>
  <div class="ma-10">
    <login v-if="!loggedin || (loggedin && user.isAnonymous)"/>
    <div v-if="loggedin && !user.isAnonymous">

      <!--      <v-btn color="secondary" rounded @click="testmail">Sende Testmail</v-btn>-->
      <v-app-bar fixed>
        <v-col>
          <span>
          <v-btn color="secondary" rounded @click="reload" :loading="loadingOrders"><v-icon left>mdi-reload</v-icon>Reload</v-btn>
          </span>
        </v-col>
        <v-row justify="center">
          <div class="headline"  @click="$router.push('/admin')" :style="{ cursor: 'pointer'}">{{ $t('title') }}</div>
        </v-row>
        <v-col style="text-align: right">
          <v-btn icon @click="showPrintJobs = !showPrintJobs" class="mr-2">
            <v-icon>{{ showPrintJobs ? 'mdi-printer-off' : 'mdi-printer' }}</v-icon>
          </v-btn>
          <v-btn color="secondary" rounded @click="$store.dispatch('user/logout')">Logout</v-btn>
        </v-col>
      </v-app-bar>
      <v-row>
        <v-col cols="12" sm="5">
          <v-text-field clearable label="Suche" v-model="search"></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-select
              :items="completedFilterValues"
              v-model="completedFilterValue"
              label="Filter Erledigte"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="2">
          <v-select
              :items="viewTableValues"
              v-model="viewTable"
              label="Darstellung"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="2">
          <v-checkbox v-model="useSmb" style="float:left" label="SMB">SMB</v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="5">
          <v-text-field clearable label="Als Produziert markieren" v-model="produced" @keyup.enter="onSetProduced"></v-text-field>
        </v-col>
      </v-row>

      <!-- NEUE ROW FÜR LAYOUT MIT RECHTER SEITE -->
      <v-row>
        <!-- LINKE SEITE: Bestehende Bestellungen -->
        <v-col cols="12" :md="showPrintJobs ? 10 : 12">

    <participants-table
        v-show="viewTable"
        v-if="loggedin && !user.isAnonymous"
        :participants="filteredItems"
        :loading="false"
    />
    <v-data-iterator
        v-show="!viewTable"
        v-if="loggedin && !user.isAnonymous"
        :items="filteredItems"
        :items-per-page="itemsPerPage"
        :footer-props="{
          itemsPerPageOptions: [15, 25, 50, 100, -1],
          itemsPerPageText: 'Einträge pro Seite:',
          itemsPerPageAllText: 'Alle'
        }"
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
              v-for="(item) in props.items"
              :key="item.uid"
              cols="12" sm="12" md="6" lg="4" xl="4"
              class="d-sm-flex align-stretch"
          >
            <v-hover
                v-slot:default="{ hover }"
                open-delay="0"
            >
              <v-card :elevation="hover? 10: 5" class="d-sm-flex justify-space-between flex-column" style="width: 100%">
                <div>
                  <div class="d-sm-flex  justify-space-between  align-stretch ">
                    <!--                        <div style="background-color: transparent" class="">-->
                    <v-card elevation="0" >
                      <v-card-title>
                        {{ item.data.metadata.lastname }} {{ item.data.metadata.firstname }}
                      </v-card-title>
                      <v-card-subtitle>
                        <div class="font-weight-bold" >Order: {{ item.data.order ? item.data.order.orderId : 'unknown' }}</div>
                        <div>Datum: {{ getCreateDate(item) }}</div>

                            <v-chip
                                v-if="getPrintJobForOrder(item)"
                                small
                                :color="getStateColor(getPrintJobForOrder(item).state)"
                                @click="openPrintJobDialog(item)"
                                style="cursor: pointer;"
                            >
                              {{ $t(`printJob.states.${getPrintJobForOrder(item).state}`) }}
                            </v-chip>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="12" sm="12" md="12">
                            <div class="mb-4">
                              <div class="font-weight-bold">
                                <v-icon small left>mdi-home</v-icon>
                                Adresse
                              </div>
                              <div>{{ item.data.metadata.lastname }} {{ item.data.metadata.firstname }}</div>
                              <div>{{ item.data.metadata.street }}</div>
                              <div>{{ item.data.metadata.zip }} {{ item.data.metadata.city }}</div>
                              <!--                            <div>Country: {{ item.country }}</div>-->
                            </div>

                            <div class="mb-4">
                              <div class="font-weight-bold">
                                <v-icon small left>mdi-human</v-icon>
                                Kontakt
                              </div>
                              <div>{{ "E-Mail" }}: {{ item.data.metadata.email }}</div>
                              <div>{{ "Telefon" }}: {{ item.data.metadata.phone }}</div>

                            </div>
                            <div class="mb-0">
                              <div class="font-weight-bold">
                                <v-icon small left>mdi-cart</v-icon>
                                Bestellung
                              </div>
                              <div>{{ "Anzahl" }}: {{ item.data.metadata.quantity }}</div>
                              <div>{{ "Gesamtpreis" }}:
                                {{ (item.data.metadata.quantity * item.data.metadata.price).toFixed(2) }} EUR
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <!--                        </div>-->
                    <div class="d-none d-sm-flex flex-column" :class="(item.data.payment && item.data.payment.paid) ?  'success' : '' ">
                      <!--                        src="https://firebasestorage.googleapis.com/v0/b/wkv-matching-plattform.appspot.com/o/files%2FDRVCv5iJbfN2a9Lxj8UQDkstE9p2%2Fduale-akademie_a3_300dpi_v2_ohne_schatten_RGB.jpg?alt=media&token=279e6ea7-329c-448b-a22e-ddaf37cfc49a"-->

                      <v-img
                          v-if="item.data.files && item.data.files.org && item.data.files.org.url"
                          class="ma-3"
                          position="center center"
                          max-width="180"
                          max-height="180"
                          :src="item.data.files.org.url"
                      />
                      <v-card-text v-if="item.data.payment && item.data.payment.paid" class="success">
                        <div>B E Z A H L T</div>
<!--                        <div>{{ item.data.payment }}</div>-->
                      </v-card-text>
                      <v-card-text v-if="item.data.production && item.data.production.finished" class="warning">
                        <div>Produziert</div>
<!--                        <div>{{ item.data.production.date}}</div>-->
                        <div>{{ new Date(item.data.production.date.seconds * 1000).toLocaleString() }}</div>
<!--                        <div>{{ item.data.payment }}</div>-->
                      </v-card-text>
<!--                      <v-img-->
<!--                          class="ma-3"-->
<!--                          position="center center"-->
<!--                          max-width="180"-->
<!--                          max-height="180"-->
<!--                          :src="item.data.files.print.url"-->
<!--                      />-->
                      <!--                          <v-img :src="item.data.project_image" max-width="250" />-->
                    </div>
<!--                    <v-card-text v-if="item.data.payment && item.data.payment.paid" class="success">Bezahlt</v-card-text>-->
                  </div>
                  <div>

                  </div>
                </div>
                <v-card-actions>

                  <v-btn text @click="download(item)">
                    <v-icon left>mdi-download</v-icon>
                    Download
                  </v-btn>
<!--                  <v-spacer></v-spacer>-->
<!--                  <v-btn text @click="print(item)">-->
<!--                    <v-icon left>mdi-printer</v-icon>-->
<!--                    Drucken-->
<!--                  </v-btn>-->
                  <v-spacer></v-spacer>
                  <v-btn text @click="printJob(item)" :loading="loadingPrintJobOrderId === item.data.orderId" :disabled="loadingPrintJobOrderId === item.data.orderId">
                    <v-icon left>mdi-printer</v-icon>
                    Drucken
                  </v-btn>
                  <v-spacer></v-spacer>
<!--                  <v-btn text @click="deleteOrder(item)">-->
<!--                    <v-icon left>mdi-delete</v-icon>-->
<!--                    Delete-->
<!--                  </v-btn>-->
<!--                  <v-spacer></v-spacer>-->
                  <v-btn text @click="mark(item)">
                    <v-icon left>{{
                        item.data.completed ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
                      }}
                    </v-icon>
                    Erledigt
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
        </v-col>

        <!-- RECHTE SEITE: PrintJobs Komponente -->
        <v-col cols="12" md="2" v-if="showPrintJobs">
          <print-jobs :search="search" />
        </v-col>
      </v-row>

      <!-- Print Job Details Dialog -->
      <v-dialog v-model="printJobDialog" max-width="600">
        <v-card v-if="selectedPrintJobs && selectedPrintJobs.length > 0">
          <v-card-title class="headline">
            <v-icon left>mdi-printer</v-icon>
            Print Job Details ({{ selectedPrintJobs.length }})
          </v-card-title>

          <v-card-text style="max-height: 500px; overflow-y: auto;">
            <div v-for="(printJob, index) in selectedPrintJobs" :key="printJob.id" class="mb-3 pa-2" style="background-color: rgba(0,0,0,0.02); border-radius: 4px;">
              <div class="d-flex align-center mb-1">
                <span v-if="selectedPrintJobs.length > 1" class="font-weight-bold mr-2">{{ index + 1 }}.</span>
                <v-chip
                  x-small
                  :color="getStateColor(printJob.state)"
                  class="mr-2"
                >
                  {{ $t(`printJob.states.${printJob.state}`) }}
                </v-chip>
                <span class="caption">Order: <strong>{{ printJob.orderId }}</strong></span>
                <v-spacer></v-spacer>
                <span class="caption">Menge: <strong>{{ printJob.quantity }}</strong></span>
              </div>
              <div class="caption mb-1">
                <v-icon x-small>mdi-clock-outline</v-icon> {{ formatPrintJobDate(printJob.created) }}
              </div>
              <div v-if="printJob.assignedAt || printJob.assignedTo" class="caption">
                <v-icon x-small>mdi-printer</v-icon>
                <span v-if="printJob.assignedTo">{{ printJob.assignedTo }}</span>
                <span v-if="printJob.assignedAt"> • {{ formatPrintJobDate(printJob.assignedAt) }}</span>
                <span v-if="printJob.deviceId && printJob.deviceId !== '-'"> • ID: {{ printJob.deviceId }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="printJobDialog = false">Schließen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState, mapGetters} from 'vuex'
import Login from "../components/Login";
import ParticipantsTable from "@/components/ParticipantsTable";
import PrintJobs from "@/components/PrintJobs";

// import firebase from "../../firebase.json";
// import firebase from 'firebase'

const fb = require('@/firebase/config.js');


export default {
  name: 'Admin',
  components: {
    Login,
    ParticipantsTable,
    PrintJobs,
  },
  data: () => ({
    useSmb: false,
    smbUrl: 'http://192.168.1.119:8090/api/v1/media',
    loadingOrders: false,
    loadingPrintJobOrderId: null,
    viewTable:false,
    showPrintJobs: true,
    //filteredItems: [],
    search: '',
    produced: '',
    itemsPerPage: 15,
    viewTableValues: [
      {text: "Blöcke", value: false},
      {text: "Tabelle", value: true},
    ],
    completedFilterValue: false,
    completedFilterValues: [
      {text: "Alle", value: null},
      {text: "Erledigt", value: true},
      {text: "nicht Erledigt", value: false},
    ],
    printJobDialog: false,
    selectedPrintJobs: [],

  }),
  computed: {
    ...mapState('user', {
      loggedin: state => state.loggedin,
      user: state => state.user,
      userClaims: state => state.claims,
    }),
    ...mapState({
      orders: state => state.orders,
    }),
    ...mapState('print', {
      printJobs: state => state.printJobs
    }),
    ...mapGetters('print', ['getPrintJobByOrderId', 'getAllPrintJobsByOrderId']),
    filteredItems() {
      let filtered = this.orders;

      // Filter nach completed status
      if (this.completedFilterValue !== null) {
        filtered = filtered.filter(item => item.data.completed === this.completedFilterValue);
      }

      // Filter nach Suchbegriff
      if (this.search !== null && this.search !== '') {
        filtered = filtered.filter(item =>
            item.data.metadata.firstname.toUpperCase().includes(this.search.toUpperCase()) ||
            item.data.metadata.lastname.toUpperCase().includes(this.search.toUpperCase()) ||
            item.data.metadata.email.toUpperCase().includes(this.search.toUpperCase()) ||
            item.data.order.orderId.includes(this.search)
        );
      }

      // Filter nach SMB source
      if (this.useSmb) {
        filtered = filtered.filter(item => item.data && item.data.source === 'SMB');
      }

      return filtered;
    }
  },
  mounted() {
    //this.filteredItems = this.orders;
    this.$store.dispatch('getFiles', { smb: this.useSmb, url: this.smbUrl })
    // Print Jobs Listener starten
    this.$store.dispatch('print/setupPrintJobsListener')
  },
  beforeDestroy() {
    // Listener beim Verlassen entfernen
    this.$store.dispatch('print/removePrintJobsListener')
  },
  methods: {
    reload() {
      const self = this
      self.loadingOrders = true
      this.$store.dispatch('getFiles', { smb: this.useSmb, url: this.smbUrl })
          .finally(() => {
            self.loadingOrders = false
          })
    },
    mark(item) {
      this.$store.dispatch('toggleOrderCompleted', item)
          .then((res) => {
            console.log(res);
          })
    },
    onSetProduced() {
      const self = this
      const orderId = this.produced
      this.$store.dispatch('setOrderProduced', orderId)
          .then((res) => {
            console.log(res);
            self.search = res.order.data.orderId
          })
          .finally(() => {
            self.produced = ''
          })
    },
    isObject(obj) {
      return typeof obj === 'object' && obj !== null && ! Array.isArray(obj)
    },
    getCreateDate(item) {
      return this.isObject(item.data.created) ? new Date(item.data.created.seconds * 1000).toLocaleString() : new Date(item.data.created).toLocaleString()
    },
    print(item) {
      console.log(item.data);
      const url = '';
      const win = window.open(url, name);

      var htmlString = '';
      var printCount = 1; //parseInt(item.data.metadata.quantity);

      for (var i = 0; i < printCount; i++) {
        htmlString += `<img src="${item.data.files.print.url}">`
      }

      win.document.write(htmlString);

      // win.document.write(`
      //      <img src="${item.files.print.url}">
      // `);
      //addStyles(win, styles);

      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
        // cb();

      }, 1000);

      return true;
    },
    async deleteOrder (item) {
      // const self = this
      this.$store.dispatch('deleteOrder', item)
          .then((res) => {
            console.log('delete order')
            console.log(res);
          })
      return true
    },
    async printJob (item) {
      const self = this

      // Loading-State aktivieren
      self.loadingPrintJobOrderId = item.data.orderId

      await this.$store.dispatch('print/printJob', item)
          .then(() => {
            self.$dialog.notify.info('Printjob sent!', {
              position: 'top-right',
              timeout: 2000
            })
          })
          .catch((error) => {
            self.$dialog.notify.error('Error' + error.message, {
              position: 'top-right',
              timeout: 2000
            })
          })
          .finally(() => {
            // Loading-State deaktivieren
            self.loadingPrintJobOrderId = null
          })

      return true
    },
    // testmail() {
    //
    //   var addMessage = firebase.app().functions('europe-west1').httpsCallable("testMail");
    //   var data = {uid:123};
    //   addMessage(data)
    //       .then(function (result) {
    //         console.log(result);
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //       });
    //
    // },

    download(item) {
      this.downloadFile(item.data.files.print.url, `${item.data.created}_${item.data.metadata.lastname}_${item.data.metadata.firstname}_print_songgl.jpg`);
    },

    downloadFile(requestURL, fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", requestURL);
      xhr.responseType = "blob";

      xhr.onload = function () {
        var blob = this.response;

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";

        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);

      };
      xhr.send();


      // axios({
      //   url: url,
      //   method: 'GET',
      //   responseType: 'blob',
      // }).then((response) => {
      //   var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      //   var fileLink = document.createElement('a');
      //
      //   fileLink.href = fileURL;
      //   fileLink.setAttribute('download', filename);
      //   document.body.appendChild(fileLink);
      //
      //   fileLink.click();
      // });
    },

    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(";"),
        ...arrData.map(item => Object.values(item).join(";"))
      ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },

    recreateImage (order, orderId) {
      console.log(order, orderId)
      const recreatePrintImage = fb.fire.app().functions('europe-west1').httpsCallable('recreatePrintImage')
      const data = {order, orderId}
      recreatePrintImage(data)
          .then((result) => {
            console.log('result', result)
          })
          .catch((error) => {
            console.log('error', error)
          })
    },

    getPrintJobForOrder(item) {
      return this.getPrintJobByOrderId(item.data.orderId);
    },

    getStateColor(state) {
      const colors = {
        'new': 'blue',
        'assigned': 'orange',
        'processing': 'purple',
        'printed': 'green',
        'error': 'red',
        'cancelled': 'grey'
      };
      return colors[state] || 'grey';
    },

    formatPrintJobDate(date) {
      if (!date) return '-';
      if (date.seconds) {
        return new Date(date.seconds * 1000).toLocaleString('de-DE');
      }
      return new Date(date).toLocaleString('de-DE');
    },

    openPrintJobDialog(item) {
      const printJobs = this.getAllPrintJobsByOrderId(item.data.orderId);
      if (printJobs && printJobs.length > 0) {
        this.selectedPrintJobs = printJobs;
        this.printJobDialog = true;
      }
    }
  }
}
</script>
